import { render, staticRenderFns } from "./secure.vue?vue&type=template&id=22f611fd"
import script from "./secure.vue?vue&type=script&lang=ts"
export * from "./secure.vue?vue&type=script&lang=ts"
import style0 from "./secure.vue?vue&type=style&index=0&id=22f611fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports